module.exports = __webpack_public_path__ + "static/media/image_11.5096e3ad.png";